import React from "react";
import {
  NewBox as Box,
  NewButton as Button,
  NewTypography as Typography,
} from "@bca/ui-library";
import { useRouter } from "next/router";

import TruckSVG from "../../icons/TruckSVG";
import contactUsClickHandler from "../../utils/contactUsClickHandler";
import refreshClickHandler from "../../utils/refreshClickHandler";

const GeneralErrorMessage = () => {
  const router = useRouter();
  const onRefreshClick = () => refreshClickHandler(router);

  return (
    <Box
      minHeight="calc(100vh - 570px)"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      alignSelf="center"
    >
      <TruckSVG />
      <Typography
        variant="h5"
        marginTop="lg"
        marginBottom="xs"
        color="fg_dark_1"
        textAlign="center"
      >
        We are experiencing an issue
      </Typography>
      <Typography
        variant="body-large"
        marginBottom="lg"
        maxWidth={536}
        weight="regular"
        color="fg_dark_3"
        textAlign="center"
      >
        We seem to have encountered an error, please refresh the page. If the
        error continues, please contact support.
      </Typography>
      <Box display="flex" flexDirection="row">
        <Box marginRight="lg">
          <Button
            variant="primary"
            text="Refresh"
            onClick={onRefreshClick}
          ></Button>
        </Box>
        <Button
          variant="secondary"
          text="Contact us"
          onClick={contactUsClickHandler}
        ></Button>
      </Box>
    </Box>
  );
};

export default GeneralErrorMessage;
